function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  fill: "rgba(0,0,0,0)",
  className: "st0",
  cx: 26,
  cy: 26,
  r: 26
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.8,26l7.1-7.1c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0L26,23.2l-7.4-7.4c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8 l7.4,7.4l-7.8,7.8c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l7.8-7.8l7.4,7.4c0.8,0.8,2,0.8,2.8,0c0.8-0.8,0.8-2,0-2.8L28.8,26z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "close-icon",
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      "enableBackground": "new 0 0 52 52"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/close.ed2a2c04.svg";
export { SvgComponent as ReactComponent };